'use strict';

// Dependancies
import "babel-polyfill"

// Modules
import Header from './modules/header'
import Slider from './modules/slider'
import Listings from './modules/listings'
import ListingsDetail from './modules/listingsDetail'
import Overlay from './modules/overlay'
import VerticalGallery from './modules/vertical-gallery'
import Accordion from './modules/accordion'
import Share from './modules/share'
import Swiper from './modules/swiper'
import ScrollAnimation from './modules/scrollAnimation'
import PageTransition from './modules/pageTransition'
import Contact from './modules/contact'
import ListingNavFix from './modules/listingNavFix'
import ListingsSort from './modules/listings.sort'
import Load from './modules/load'
import VideoStart from './modules/videoStart'
import GuideBookFlip from './modules/guideBookFlip'
import mcAjaxSubmit from './modules/mcAjaxSubmit'
import BuildingFilter from './modules/buildingFilter'
import BuildingFloorplanFilter from './modules/buildingFloorplanFilter'
import Account from './modules/account'
import Reveal from './modules/reveal'
import CondoMarketReport from './modules/condoMarketReport'
import Register from './modules/register'
import BuildingListings from './modules/buildingListings'
import ScrollProgress from './modules/scrollProgress'
import GalleryOverlay from './modules/galleryOverlay'

// Global Functionality
Header.init()
Swiper.init()
Reveal.init({ elements : '.reveal-hidden' })

/*
  Conditional Functionality
  m = modules
  o = objects
  i = if condition

  - tests the if condition for each object and if true, run that objects init function
*/
const m = [
  { o : Overlay,                 i : Overlay.container },
  { o : VerticalGallery,         i : VerticalGallery.container },
  { o : Accordion,               i : Accordion.container },
  { o : Share,                   i : Share.container },
  { o : Contact,                 i : Contact.container},
  { o : ListingNavFix,           i : ListingNavFix.container},
  { o : ListingsSort,            i : ListingsSort.container},
  { o : Load,                    i : Load.container},
  { o : GuideBookFlip,           i : GuideBookFlip.container},
  { o : mcAjaxSubmit,            i : mcAjaxSubmit.container},
  { o : BuildingFilter,          i : BuildingFilter.container},
  { o : Listings,                i : Listings.container},
  { o : ListingsDetail,          i : ListingsDetail.container},
  { o : BuildingFloorplanFilter, i : BuildingFloorplanFilter.container},
  { o : Account,                 i : Account.container},
  { o : VideoStart,              i : VideoStart.video},
  { o : ScrollAnimation,         i : ScrollAnimation.homeCover},
  { o : CondoMarketReport,       i : CondoMarketReport.container},
  { o : Register,                i : Register.container},
  //{ o : BuildingListings,        i : BuildingListings.container },
  { o : ScrollProgress,          i : ScrollProgress.container },
  { o : GalleryOverlay,          i : GalleryOverlay.container }
].map( a => (a.i) ? a.o.init() : null )

// Page Transitions
if (
  document.body.classList.contains('page-template-template-buyingSellingLanding') || document.body.classList.contains('page-template-template-buyingSellingSteps')
) {
  PageTransition.init()
}

// Slider
[...document.querySelectorAll('.slider')].map( slider => new Slider(slider, { rotate : true, intervalDuration : 2000 }))
